import { gql }  from '@apollo/client';

const SHOW_RTE_PAYERS = gql`
  query {
    rtePayers {
      id
      name
      displayNames
      code
      availableForLocation
    }
  }
`;

export default SHOW_RTE_PAYERS;
